import React from "react";
import { useLanguage } from "lang/Translate";

import InfoFlyout from "components/common/InfoFlyout/InfoFlyout";

const FuelPriceController = () => {
	const currLanguage = useLanguage();
	const icon = (
		<i
			className="fas fa-chart-line"
			title={currLanguage === "PL" ? "Obecna cena twoich akcji" : "Your current stock value"}
		/>
	);

	return <InfoFlyout icon={icon} value={"N/A"} />;
};

export default FuelPriceController;
